import { PrimaryButton } from '@/lib';

export function SensorStep({ onCompleted }: { onCompleted: () => void }) {
  return (
    <div className="flex flex-col gap-sp-4">
      <p className="text-fs-body text-gray-700">
        Register at least one sensor. Use the Commissioning wizard for
        the full BLE pairing flow; otherwise the dev fixture ships
        with sensors already paired.
      </p>
      <p className="text-fs-meta text-gray-700">
        Sensor registration runs through the sensor-ingestion service —
        the wizard's counter hook will go live alongside the
        forwarder-tap. For now, acknowledge below to continue.
      </p>
      <PrimaryButton label="I've registered my sensors" onClick={onCompleted} />
    </div>
  );
}
